import { Layout } from 'antd'
import { DefaultSeo } from 'next-seo'
import { connect } from 'react-redux'

import { getBroswerInfo, getPayloadClearQS } from '~/common'
import { ChannelConstants } from '~/common/constants'

const StyledLayout = ({ Component, pageProps, lender, sandboxLender }) => {
  const payload = getPayloadClearQS()
  let browserInfo

  if (
    payload === ChannelConstants.SANDBOX ||
    payload === ChannelConstants.OPS
  ) {
    browserInfo = getBroswerInfo(sandboxLender)
  } else {
    browserInfo = getBroswerInfo(lender)
  }

  return (
    <>
      <DefaultSeo
        dangerouslySetAllPagesToNoIndex={true}
        dangerouslySetAllPagesToNoFollow={true}
        title={browserInfo?.title}
        description={browserInfo?.description}
        additionalLinkTags={[
          {
            rel: 'icon',
            href: browserInfo?.icon || '/NF/favicon.png',
          },
          {
            rel: 'stylesheet',
            href: browserInfo?.stylesheet || '/NF/nationalfunding.css',
          },
        ]}
      />
      <Layout className="bg-surfaceBackground">
        <Component {...pageProps} />
      </Layout>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    lender: state.lender,
    sandboxLender: state.sandboxLender,
  }
}

export default connect(mapStateToProps, null)(StyledLayout)
